<template>
  <div class="main-container">
    <home-nav-bar v-if="$store.getters.isLogin" title="查看溯源">
      <template #left>
        <router-link :to="{name: 'PackingList'}">
          <van-icon name="arrow-left" />
        </router-link>
      </template>
    </home-nav-bar>
    <init-two v-if="radarShow" :show.sync="radarShow" :tab-list="tabList" />
    <div v-show="!radarShow" class="primary">
      <pick-info class="content-item" :trace-data="pickInfo" product-type="packing" />
      <div class="content-item intro">
        <unit-title title="产品简介" />
        <div>{{ pickInfo.productIntroduction }}</div>
      </div>
      <test-report-list v-if="allTestReportList.length" class="content-item module" :test-report-list="allTestReportList" product-type="packing" />
      <farm-land-data class="content-item module" :user-id="userId" product-type="packing" />
      <process-link class="content-item module" :process-link="processLink" />
      <raw-trace class="content-item module" :raw-trace="rawTrace" />
      <company-data class="content-item module" :company-data="companyTraceDate" />
      <div class="bottom-fix-box">
        <div class="content wh-flex-between">
          <div class="left-content">
            <div class="percent">
              100%
            </div>
            <div class="annotation">
              资源完整度
            </div>
          </div>
          <div class="right-content">
            <van-button v-if="$store.getters.isLogin" class="btn" round native-type="button" type="info" @click="editTraceSource">
              编辑溯源
            </van-button>
            <van-button class="btn" round native-type="button" type="primary" @click="viewTraceSourceQr">
              查看溯源码
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <qr-trace-dialog v-model="traceCodeQrDialogShow" state="pack" :trance-code="traceCode" />
  </div>
</template>

<script>
import api from '@/api'
import HomeNavBar from '@/views/layout/components/HomeNavBar'
import InitTwo from '@/views/productManage/TraceSource/components/InitTwo'
import QrTraceDialog from '@/views/productManage/TraceSource/components/QrTraceDialog'
import FarmLandData from '@/views/productManage/TraceSource/components/FarmLandData'
import PickInfo from '@/views/productManage/TraceSource/components/PickInfo'
import TestReportList from '@/views/productManage/TraceSource/components/TestReportList'
import CompanyData from '@/views/productManage/TraceSource/components/CompanyData'
import ProcessLink from '@/views/productManage/TraceSource/components/ProcessLink'
import RawTrace from '@/views/productManage/TraceSource/components/RawTrace'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
export default {
  name: 'TracePacking',
  components: { UnitTitle, CompanyData, TestReportList, PickInfo, FarmLandData, QrTraceDialog, InitTwo, HomeNavBar, ProcessLink, RawTrace },
  props: {
    // 通过绑定 route.query 传递
    traceCode: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      tabList: [
        {
          name: '权威检测',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '产地信息',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '加工环节',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '原料追溯',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        },
        {
          name: '生产企业',
          icon: 'selection',
          secIcon: 'choice',
          iconTxt: '可追溯',
          show: false
        }
      ],
      radarShow: true,
      traceCodeQrDialogShow: false,
      pickInfo: {},
      farmlandData: {},
      selectedFarmWorkRecords: [],
      allTestReportList: [],
      companyTraceDate: {},
      farmWorkJSON: [],
      processLink: {},
      rawTrace: [],
      userId: undefined
    }
  },
  watch: {
    traceCode: {
      async  handler(newVal) {
        if (newVal) {
          await this.initTranceSource(newVal)
        }
      },
      immediate: true
    }
  },
  created() {
    setTimeout(() => {
      this.radarShow = false
    }, 100) // 最多展示 6s 隐藏雷达追溯动画
  },
  methods: {
    async initTranceSource(traceCode) {
      await api.getPackingTraceByTraceCode({ traceCode }).then(res => {
        this.userId = res.data.userId
        this.pickInfo = res.data
        this.processLink = res.data.processingJson || {}
        this.rawTrace = res.data.rawMaterialsInfo
        this.allTestReportList = res.data.reportInfo || []
        this.companyTraceDate = res.data.companyInfo || []
      })
    },
    editTraceSource() {
      this.$router.push({
        name: 'TracePackingEdit',
        query: {
          traceCode: this.traceCode
        }
      })
    },
    viewTraceSourceQr() {
      this.traceCodeQrDialogShow = true
    }
  }
}
</script>

<style lang='less' scoped>
.main-container {
  background: #f6f5f5;
}
.primary {
  .content-item {
    margin-top: 8px;
    background: #ffffff;
    &.module {
      padding: 16px;
    }
  }
  .intro{
    padding: 16px;
    font-size: 14px;
  }
}
.bottom-fix-box {
  @height: 64px;
  height: @height; //用于占位
  display: block;
  width: 100%;
  .content {
    z-index: 2;
    height: @height;
    position: fixed;
    letter-spacing: 0.2em;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px 10px;
    box-shadow: 0 0 10px 0 #ccc;
    background: #fff;
    .left-content {
      .percent {
        color: #e85f1a;
      }
      .annotation {
        font-size: 12px;
        color: #cccccc;
      }
    }
    .right-content {
      .btn + .btn {
        margin-left: 10px;
      }
    }
  }
}
</style>
